module.exports = __webpack_public_path__ + "static/logo_excent-ef63e9b9122b12e444b2b4a482968643.jpg";